import { format } from 'date-fns';

import { DatePickerDisplayFormat } from 'components/generic-question/DateTimePickers';

export const getDisplayText = (date: Date): string =>
  format(date, DatePickerDisplayFormat.TIME_FORMAT_12H);
